module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-481.a3b7f9e.woff2";